import { render, staticRenderFns } from "./KucunManagement.vue?vue&type=template&id=4e0f3e98&scoped=true&"
import script from "./KucunManagement.vue?vue&type=script&lang=js&"
export * from "./KucunManagement.vue?vue&type=script&lang=js&"
import style0 from "./KucunManagement.vue?vue&type=style&index=0&id=4e0f3e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f3e98",
  null
  
)

export default component.exports